import { Component } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { InscricaoService } from '../../../services/inscricao.service';
import { CustomValidator } from '../../shared/validators/custom.validator';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { ConsultaCnpjService } from '../consulta-cnpj.service';

@Component({
  templateUrl: './consulta-cnpj.component.html',
})
export class ConsultaCnpjComponent extends WebPage {

  mensagem = '';
  form: FormGroup;
  constructor(fb: FormBuilder, private consultaCnpjService: ConsultaCnpjService, messageService: MessageService) {
    super(messageService);

    this.form = fb.group({
      email: ['', [Validators.required, Validators.email]],
      cnpj: ['', [Validators.required, CustomValidator.CNPJValidator]]
    });
  }

  get email() { return this.form.get('email'); }
  get cnpj() { return this.form.get('cnpj'); }

  consultaCnpj() {
    if (this.form.invalid) {
      return;
    }

    this.isLoading = true;
    this.consultaCnpjService.consultaCnpj(this.form.value)
      .finally(() => this.isLoading = false)
      .subscribe(
        resultado => {
          switch (resultado) {
            case 'VÁLIDO':
            case 'DEFERIDO':
              this.mensagem = `
                O CNPJ encontra-se vinculado ao  SEST SENAT.<br />
                Consulte o período de inscrição no Edital.<br />
                Informações: 0800 728 2891
              `;
              break;
            case 'PENDENTE':
            case 'INVÁLIDO':
              this.mensagem = 'O CNPJ informado está em análise. Aguarde retorno desta consulta, por e-mail, em até 3 dias.';
              break;
            case 'INDEFERIDO':
              this.mensagem = `
                AVISO!<br />
                Este CNPJ já foi consultado.<br />
                Constatou-se que a atividade econômica principal do cadastro empresarial não é do setor de transporte,<br />
                não sendo possível o atendimento, neste projeto.<br />
                Para maiores informações consulte as regras do edital disponível no site www.sestsenat.org.br<br />
                ou procure a Unidade Operacional do SEST SENAT.<br />
                Agradecemos o contato. <br />
                SEST SENAT
              `;
              break;
          }
        },
        error => this.gerenciaErro(error)
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/consultaCnpj/consulta-cnpj/consulta-cnpj.component.ts